import { Map as ImmutableMap } from 'immutable';

/**
 * Timezones that keep their own group instead of being listed along with
 * other countries/cities that share the same timezone rules, e.g.
 * - due to geo-politics https://issues.hubspotcentral.com/browse/SMMC-6458
 * - because a jurisdiction adopted its own time policy, such as the Canadian
 *   provinces that ended seasonal time changes on 2026-11-01
 */
export default ImmutableMap({
  'Asia/Yerevan': 'Yerevan',
  'America/Vancouver': 'Vancouver',
  'America/Edmonton': 'Edmonton',
  'America/Inuvik': 'Edmonton',
  'America/Yellowknife': 'Edmonton',
  'America/Winnipeg': 'Winnipeg',
  'America/Rainy_River': 'Winnipeg'
});